import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { MutationService } from '@GraphQL/mutation/mutation.service';
import { State } from '@Ngrx/reducers';
import { searchSelectors } from '@Ngrx/selectors';
import { Store } from '@ngrx/store';
import { Subscription, map, of, switchMap } from 'rxjs';
import { GoogleMap, GoogleMapsModule, MapAdvancedMarker, MapInfoWindow } from '@angular/google-maps';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-program-search-map',
    templateUrl: './program-search-map.component.html',
    styleUrls: ['./program-search-map.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, GoogleMapsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramSearchMapComponent implements OnChanges {
    @ViewChild('map', { static: true }) mapElement: GoogleMap;
    @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;

    @Input() programs: any;

    allListPrograms: any[] = [];
    allListProgramCoordinates: object[];
    splitGeoLocArray: any[] = [];

    mapOptions: google.maps.MapOptions = {};
    bounds: google.maps.LatLngBounds;

    constructor(private store: Store<State>, private mutationService: MutationService, private location: Location, private router: Router) {}

    // only want to rebuild on changes to the programs object
    ngOnChanges(changes: SimpleChanges) {
        if (changes.programs && changes.programs.currentValue.length > 0) {
            // get list of programs from the search page
            this.allListPrograms = [];
            this.allListProgramCoordinates = [];
            this.splitGeoLocArray = [];
            try {
                // get the bounds this is lat lng
                this.bounds = new google.maps.LatLngBounds(null);
                // does this event contain any programs ?
                if (this.programs.length > 0) {
                    // loop over all programs in this list
                    for (const program of this.programs) {
                        // add each program from set to class list
                        this.allListPrograms.push(program);
                        // does this program geo loc exist
                        // if not default empty
                        const splitProgramGeoLoc = program.geoloc ? program.geoloc.split(',') : ['', ''];
                        // get ready for median, backend fnc to get median expects 2d array
                        this.splitGeoLocArray.push([splitProgramGeoLoc[0], splitProgramGeoLoc[1]]);
                        // while in here create position for calculate bounds (center)
                        const position = new google.maps.LatLng(splitProgramGeoLoc[0], splitProgramGeoLoc[1]);
                        // set node on the map
                        this.bounds.extend(position);
                    }
                    // set median zoom to wide, fitBounds will properly adjust
                    let medianZoom = 4;

                    // set map options
                    if (this.programs.length < 100) {
                        this.mapOptions = {
                            // bounds gets the map center, did that earlier for every program in this event
                            center: this.bounds.getCenter(),
                            // median zoom the backend gave us
                            zoom: medianZoom,
                            // the type of UI map
                            mapTypeId: google.maps.MapTypeId.ROADMAP,
                            mapId: 'program-search-map',
                        };
                    } else {
                        // if there are many programs center is midwest
                        const latLng = new google.maps.LatLng(41.8781, -87.6298);
                        // define map options
                        this.mapOptions = {
                            center: latLng, // midwest
                            zoom: medianZoom, // probably high like 12
                            mapTypeId: google.maps.MapTypeId.ROADMAP,
                            mapId: 'program-search-map',
                        };
                    }

                    this.allListProgramCoordinates = this.allListPrograms.map((program: any) => {
                        const _position = program.geoloc ? program.geoloc.split(',') : ['', ''];
                        const _coordinates = new google.maps.LatLng(_position[0], _position[1]);
                        this.bounds.extend(_coordinates);
                        const imgTag = document.createElement('img');
                        imgTag.src = '/img/orange_pin_1.png';
                        const content =
                            '<div class="ion-text-center">' +
                            '<a href="/program/' +
                            program.id +
                            '"><h4>' +
                            program.name +
                            '</h4></a>' +
                            '<div>' +
                            program.city +
                            ' ' +
                            program.state +
                            '</div>' +
                            '<div>' +
                            program.specialty +
                            '</div>' +
                            '<div>' +
                            program.type +
                            '</div>' +
                            '<ion-button href="/program/' +
                            program.id +
                            '">Apply Now!</ion-button>' +
                            '</div>';
                        return {
                            position: { lat: _coordinates.lat(), lng: _coordinates.lng() },
                            icon: imgTag,
                            title: program.name,
                            windowContent: content,
                        };
                    });
                }
            } catch (e) {
                console.log(e);
            }
            this.adjustBounds();
            // });
        }
    }

    adjustBounds() {
        if (this.mapElement.googleMap) {
            google.maps.event.addListenerOnce(this.mapElement.googleMap, 'idle', () => {
                this.mapElement.googleMap.fitBounds(this.bounds, 40);
            });
        }
    }

    onMarkerClick(marker: MapAdvancedMarker, content: string) {
        // open the info window
        this.infoWindow.open(marker, false, content);
    }

    getQueryParams() {
        const urlParams = new URLSearchParams(window.location.search);
        return Object.fromEntries(urlParams.entries());
    }
}
